import { render, staticRenderFns } from "./PirosMogyoros.vue?vue&type=template&id=c41e8366&"
import script from "./PirosMogyoros.vue?vue&type=script&lang=js&"
export * from "./PirosMogyoros.vue?vue&type=script&lang=js&"
import style0 from "./PirosMogyoros.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports